const photos = [
  {
    src: process.env.PUBLIC_URL + "/gallery/photo1.jpg",
    title: "gallery.part1",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo2.jpg",
    title: "gallery.part2",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo3.jpg",
    title: "gallery.part3",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo4.jpg",
    title: "gallery.part4",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo5.jpg",
    title: "gallery.part5",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo6.jpg",
    title: "gallery.part6",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo7.jpg",
    title: "gallery.part7",
    width: 3,
    height: 4
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo8.jpg",
    title: "gallery.part8",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo9.jpg",
    title: "gallery.part9",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo10.jpg",
    title: "gallery.part10",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo11.jpg",
    title: "gallery.part11",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo12.jpg",
    title: "gallery.part12",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo13.jpg",
    title: "gallery.part13",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo14.jpg",
    title: "gallery.part14",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo15.jpg",
    title: "gallery.part15",
    width: 3,
    height: 4
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo16.jpg",
    title: "gallery.part16",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo17.jpg",
    title: "gallery.part17",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo18.jpg",
    title: "gallery.part18",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo19.jpg",
    title: "gallery.part19",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo20.jpg",
    title: "gallery.part20",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo21.jpg",
    title: "gallery.part21",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo22.jpg",
    title: "gallery.part22",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo23.jpg",
    title: "gallery.part23",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo24.jpg",
    title: "gallery.part24",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo25.jpg",
    title: "gallery.part25",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo26.jpg",
    title: "gallery.part26",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo27.jpg",
    title: "gallery.part27",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo28.jpg",
    title: "gallery.part28",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo29.jpg",
    title: "gallery.part29",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo30.jpg",
    title: "gallery.part30",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo31.jpg",
    title: "gallery.part31",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo32.jpg",
    title: "gallery.part32",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo33.jpg",
    title: "gallery.part33",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo34.jpg",
    title: "gallery.part34",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo35.jpg",
    title: "gallery.part35",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo36.jpg",
    title: "gallery.part36",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo37.jpg",
    title: "gallery.part37",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo38.jpg",
    title: "gallery.part38",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo39.jpg",
    title: "gallery.part39",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo40.jpg",
    title: "gallery.part40",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo41.jpg",
    title: "gallery.part41",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo42.jpg",
    title: "gallery.part42",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo43.jpg",
    title: "gallery.part43",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo44.jpg",
    title: "gallery.part44",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo45.jpg",
    title: "gallery.part45",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo46.jpg",
    title: "gallery.part46",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo47.jpg",
    title: "gallery.part47",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo48.jpg",
    title: "gallery.part48",
    width: 3,
    height: 2
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo49.jpg",
    title: "gallery.part49",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo50.jpg",
    title: "gallery.part50",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo51.jpg",
    title: "gallery.part51",
    width: 3,
    height: 4
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo52.jpg",
    title: "gallery.part52",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo53.jpg",
    title: "gallery.part53",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo54.jpg",
    title: "gallery.part54",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo55.jpg",
    title: "gallery.part55",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo56.jpg",
    title: "gallery.part56",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo57.jpg",
    title: "gallery.part57",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo58.jpg",
    title: "gallery.part58",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo59.jpg",
    title: "gallery.part59",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo60.jpg",
    title: "gallery.part60",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo61.jpg",
    title: "gallery.part61",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo62.jpg",
    title: "gallery.part62",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo63.jpg",
    title: "gallery.part63",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo64.jpg",
    title: "gallery.part64",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo65.jpg",
    title: "gallery.part65",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo66.jpg",
    title: "gallery.part66",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo67.jpg",
    title: "gallery.part67",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo68.jpg",
    title: "gallery.part68",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo69.jpg",
    title: "gallery.part69",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo70.jpg",
    title: "gallery.part70",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo71.jpg",
    title: "gallery.part71",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo72.jpg",
    title: "gallery.part72",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo73.jpg",
    title: "gallery.part73",
    width: 4,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo74.jpg",
    title: "gallery.part74",
    width: 3,
    height: 3
  },
  {
    src: process.env.PUBLIC_URL + "/gallery/photo75.jpg",
    title: "gallery.part75",
    width: 4,
    height: 3
  }
];
export default photos;
